export default __webpack_public_path__ + "static/media/mateus-pontes-x2TDul-JMl8-unsplash.c0d93a9f.jpg";